import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const AdriagateLogo = ({ width = '80', height = '32', fill = '#004568' }: IIconProps) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 865 191"
    xmlSpace="preserve"
  >
    <path
      fill={fill}
      d="M68.9,123c-2.2,1.4-4.7,2.3-7.3,2.7c-3.6,0.8-7.4,1.2-11.1,1.1c-6.7,0-11.5-1.1-14.5-3.3
	c-3-2.1-4.6-5.5-4.5-9.1c0-3.9,1.5-6.8,4.4-8.6s7.2-3,12.8-3.5l20.3-1.8V123z M82.3,52.8c-8.1-5.7-19.1-8.5-32.7-8.5
	c-5.3,0-10.5,0.4-15.7,1.2c-4.7,0.7-9.4,1.9-13.8,3.6c-2.5,1-4.6,2.6-6.4,4.6c-1.4,1.9-2.1,4.2-2,6.6c0,2.1,0.5,4.2,1.6,6
	c1,1.7,2.3,3.2,3.9,4.3c4.4-2,9.1-3.6,13.8-4.8c5.2-1.3,10.5-1.9,15.9-1.9c7,0,12.4,1.2,16.2,3.7s5.8,6.2,5.8,11.4v3.7l-28.7,2.8
	c-11.3,1.1-19.9,4-25.8,8.8c-5.9,4.8-8.8,11.7-8.9,20.8c0,10.4,4,18.2,12,23.4c8,5.2,19,7.8,32.9,7.8c6.9,0.1,13.8-0.6,20.5-2
	c5.2-1,10.2-2.9,14.9-5.5c2.3-1.4,4.5-3.1,6.3-5.1c1.8-2.2,2.7-4.9,2.5-7.7V79.2C94.5,67.3,90.5,58.5,82.3,52.8"
    />
    <path
      fill={fill}
      d="M182,121.8c-2.1,1.2-4.3,2.2-6.6,2.8c-3,0.9-6.2,1.3-9.3,1.2c-8.5,0-15.2-2.4-20.2-7.2s-7.4-12.4-7.4-22.8
	c0-11.1,2.6-19.1,7.7-23.9c5.2-4.9,11.6-7.3,19.5-7.3c3,0,6.1,0.4,9,1.2c2.6,0.7,5,1.7,7.3,3L182,121.8z M193.9,9.8
	c-2.3,0-4.7,0.2-7,0.5c-1.7,0.2-3.3,0.6-4.9,1.1v36.7c-2.9-1.2-5.9-2.1-9-2.7c-3.5-0.8-7.1-1.1-10.7-1.1c-6.7-0.1-13.5,1-19.9,3
	c-5.9,1.9-11.4,5.1-16,9.3c-4.7,4.5-8.4,9.9-10.8,15.9c-2.7,6.4-4,14.1-4,23c0,17.2,4.9,30,14.7,38.3c9.8,8.3,23.1,12.5,39.8,12.5
	c6.7,0.1,13.4-0.8,19.9-2.7c4.8-1.4,9.5-3.4,13.8-6c2.4-1.4,4.6-3.3,6.3-5.5c1.5-2.2,2.2-4.8,2.1-7.5V21.8c0-4.5-1.2-7.6-3.5-9.3
	S198.9,9.8,193.9,9.8"
    />
    <path
      fill={fill}
      d="M275.3,44.3c-6.9-0.1-13.9,0.8-20.6,2.4c-5.6,1.3-11,3.4-16,6.3c-2.9,1.6-5.4,3.8-7.3,6.5
	c-1.7,2.6-2.6,5.8-2.5,8.9v64.3c0,4.5,1.2,7.6,3.5,9.3s6,2.7,10.9,2.7c2.4,0,4.8-0.2,7.1-0.6c2.1-0.4,3.8-0.8,5-1V70.5
	c3.5-1.8,7.2-3.2,11.1-4.1c4.5-1.1,9.2-1.7,13.8-1.6c4-0.1,8,0.3,11.9,1c0.8-1.3,1.5-2.7,2-4.1c0.6-1.7,1-3.6,0.9-5.4
	C295.1,48.2,288.5,44.2,275.3,44.3"
    />
    <path
      fill={fill}
      d="M320.6,46.3c-2.3,0-4.7,0.2-7,0.6c-2.2,0.4-3.8,0.7-4.9,1v84.8c0,4.5,1.1,7.6,3.4,9.3c2.3,1.8,6,2.6,11,2.6
	c2.3,0,4.7-0.2,7-0.6c2.2-0.4,3.8-0.7,4.9-1V58.3c0-4.5-1.1-7.6-3.5-9.3S325.7,46.3,320.6,46.3"
    />
    <path
      fill={fill}
      d="M321.9,4.3c-4.1-0.2-8.1,1.3-11,4.2c-2.8,2.6-4.3,6.2-4.3,10c-0.1,3.9,1.5,7.6,4.3,10.2c2.9,2.8,6.9,4.3,11,4.2
	c4,0.2,8-1.3,10.9-4.2c2.8-2.7,4.3-6.4,4.2-10.2c0-3.8-1.5-7.4-4.2-10C329.9,5.7,326,4.2,321.9,4.3"
    />
    <path
      fill={fill}
      d="M417.9,123c-2.2,1.4-4.7,2.3-7.3,2.7c-3.6,0.8-7.4,1.2-11.1,1.1c-6.7,0-11.5-1.1-14.5-3.3
	c-3-2.1-4.7-5.5-4.5-9.1c0-3.9,1.5-6.8,4.4-8.6s7.2-3,12.8-3.5l20.3-1.8V123z M431.4,52.8c-8.2-5.7-19.1-8.5-32.7-8.5
	c-5.3,0-10.5,0.4-15.7,1.2c-4.7,0.7-9.4,1.9-13.8,3.6c-2.5,1-4.6,2.6-6.4,4.6c-1.4,1.9-2.1,4.2-2,6.6c0,2.1,0.5,4.2,1.6,6
	c0.9,1.7,2.3,3.2,3.9,4.3c4.4-2,9.1-3.6,13.8-4.8c5.2-1.3,10.5-1.9,15.9-1.9c7,0,12.4,1.2,16.2,3.7c3.8,2.4,5.8,6.2,5.8,11.4v3.7
	l-28.6,2.8c-11.3,1.1-19.9,4-25.9,8.8s-8.8,11.7-8.8,20.8c0,10.4,4,18.2,12,23.4c8,5.2,19,7.8,33,7.8c6.9,0.1,13.8-0.6,20.5-2
	c5.2-1,10.2-2.9,14.9-5.5c2.3-1.4,4.5-3.1,6.3-5.1c1.8-2.2,2.7-4.9,2.5-7.7V79.2C443.6,67.3,439.5,58.5,431.4,52.8"
    />
    <path
      fill={fill}
      d="M533,114.5c-2.3,1.6-4.8,2.9-7.4,3.9c-3.3,1.2-6.8,1.7-10.3,1.6c-3.2,0-6.4-0.5-9.4-1.4
	c-2.9-0.9-5.5-2.5-7.6-4.7c-2.3-2.4-4-5.3-5-8.5c-1.3-4.2-1.9-8.6-1.8-13c0-9.5,2.3-16.5,7-21c4.7-4.5,10.8-6.8,18.5-6.8
	c3.2-0.1,6.3,0.3,9.3,1.2c2.4,0.7,4.6,1.7,6.8,2.8L533,114.5z M550.6,53c-4.6-2.7-9.5-4.7-14.6-6.1c-6.5-1.8-13.2-2.7-20-2.6
	c-7.1-0.1-14.2,0.9-20.9,3c-6,1.9-11.5,5-16.2,9.1c-4.6,4.2-8.2,9.3-10.5,15.1c-2.6,6.6-3.8,13.7-3.7,20.8c0,8.7,1.2,16,3.7,22
	c2.1,5.6,5.5,10.6,9.9,14.7c4.2,3.8,9.2,6.6,14.7,8.2c5.8,1.7,11.8,2.6,17.8,2.5c4.3,0.1,8.7-0.4,12.9-1.4c3.3-0.8,6.6-2,9.7-3.5
	v8.7c0,6.9-2.4,11.9-7.1,15s-11.3,4.7-19.7,4.7c-5.6,0-11.2-0.8-16.5-2.4c-4.6-1.4-9-3.3-13.2-5.7c-1.7,1.1-3,2.5-4,4.3
	c-1.2,2-1.7,4.4-1.7,6.7c0,4.7,2.3,8.5,6.9,11.4c2.7,1.6,6.7,3.1,12,4.4c6.2,1.4,12.6,2,18.9,1.9c6.5,0,13.1-0.7,19.4-2.3
	c5.6-1.3,11-3.7,15.7-7c4.5-3.2,8.1-7.4,10.6-12.3c2.7-5.6,4-11.7,3.9-17.8V66.2c0.1-2.7-0.7-5.4-2.2-7.7c-1.6-2.2-3.7-4.1-6-5.5"
    />
    <path
      fill={fill}
      d="M604.6,109.7c0.8-3.8,2.8-6.4,6.1-7.6s7.7-1.5,13.2-1l20.3,2.2l-4.7,22c-2.5,0.9-5.1,1.3-7.7,1.3
	c-3.7,0-7.4-0.3-11.1-1.1c-6.5-1.3-11.1-3.3-13.6-6C604.6,116.8,603.7,113.1,604.6,109.7 M616.6,144.6c6.7,1.4,13.6,2.1,20.5,2
	c5.3,0,10.6-0.8,15.7-2.4c2.6-0.9,5-2.1,7.2-3.8c2.2-1.8,3.6-4.2,4.1-7l9.8-45.9c2.5-11.7,0.3-21.1-6.5-28.2
	c-6.8-7.2-16.9-12.1-30.3-14.7c-5.2-1-10.4-1.7-15.6-1.9c-4.8-0.2-9.6,0-14.3,0.9c-2.6,0.5-5.1,1.6-7.2,3.2
	c-1.7,1.6-2.9,3.7-3.3,6.1c-0.5,2-0.4,4.2,0.3,6.2c0.6,1.9,1.6,3.6,2.9,5c4.8-1.1,9.6-1.8,14.5-2c5.4-0.3,10.7,0.2,16,1.2
	c6.8,1.4,11.9,3.6,15.1,6.8c3.2,3.1,4.3,7.2,3.3,12.3l-0.8,3.6L619.3,83c-11.3-1.2-20.3,0-27.2,3.6c-6.8,3.5-11.1,9.7-13,18.6
	c-2.2,10.2,0.1,18.7,6.9,25.3C592.8,137.1,603,141.8,616.6,144.6"
    />
    <path
      fill={fill}
      d="M744.9,69.3c2.5,0.1,4.9-0.8,6.7-2.5c1.7-1.6,2.5-4.2,2.5-7.7c0-1.9-0.3-3.8-0.8-5.7c-0.4-1.5-1.1-2.9-1.9-4.3
	h-30.8V32.3c0-4.5-1.2-7.6-3.5-9.3s-5.9-2.6-10.8-2.6c-2.3,0-4.7,0.2-7,0.6c-2.2,0.4-3.8,0.8-4.9,1v93.2c0,11.1,3.2,19,9.5,23.8
	c6.3,4.8,15,7.2,26,7.2c8.4,0,14.4-1.3,18.2-4s5.7-6,5.7-10c0-1.9-0.4-3.7-1.2-5.4c-0.7-1.5-1.7-2.8-2.8-4c-2.1,0.9-4.3,1.5-6.6,2
	c-2.4,0.5-4.8,0.8-7.2,0.8c-4.9,0-8.7-0.9-11.4-2.8s-4.1-5-4.1-9.3V69.3H744.9z"
    />
    <path
      fill={fill}
      d="M666.1,158.3c-1.7,1.2-7.2,4.9-9.4,6.1c-1.9,1.2-4.1,1.9-6.4,2c-5.7,0-8.1-1-12.1-4c-4.8-3.6-11.4-8.6-23.5-8.6
	s-17.6,4.5-23.5,8.5c-5.3,3.5-8.4,4.2-11.3,4.1c-4.5-0.2-5.4-1.3-9-0.6c-2.9,0.6-6.2,4.6-5.6,9.8c0.6,4.7,6,7.8,13.7,8.1
	c11.5,0.4,18.5-3.4,23.3-7c4-3.1,6.4-4.8,12.3-4.8s8.3,1.8,12.4,4.8c4.8,3.6,11.2,7.1,23.2,7.1c3.1,0,6.3-0.5,9.3-1.3
	c2.1-0.5,4.2-1.2,6.1-2.3c7.2-3.6,12.9-9.4,12.6-14.2C677.9,158.4,671,155,666.1,158.3"
    />
    <path
      fill={fill}
      d="M836.5,89.1h-45.9c0,0-0.4-24.4,22.5-24.4s23.4,24.2,23.4,24.2V89.1z M838.1,106.9c0,0,8.9-0.2,12.4-0.8
	c2.8-0.5,4.3-1.6,6.4-3.4c1.9-1.8,3.1-4.3,3.3-6.9c0.3-2.2,0.3-4.4,0.2-6.6c0,0,1-33.7-33.5-42.7l-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1
	h-0.1c-3.8-1-7.8-1.5-11.7-1.4c-6.7,0-12,0.5-18,2.5c-5.9,1.9-11.3,5.1-15.8,9.3c-4.7,4.4-8.3,9.7-10.8,15.6c-2.7,6.2-4,13.5-4,21.9
	c0,8.7,1.3,16.2,4.1,22.7c5.1,12.7,15.6,22.3,28.7,26.2c7.3,2.2,14.9,3.3,22.5,3.2c4.8,0,9.7-0.4,14.4-1.2c4-0.7,7.9-1.8,11.6-3.5
	c2.9-1.2,5.6-3.1,7.7-5.4c1.8-1.9,2.8-4.5,2.8-7.2c0-2.2-0.7-4.3-1.9-6.1c-1.2-1.8-2.9-3.4-4.8-4.5c-3.8,2.2-7.8,4-12,5.4
	c-5.2,1.7-10.7,2.6-16.2,2.5c-7.8,0-14.4-1.6-19.7-4.7c-5.3-3.1-8.9-8.1-10.9-15L838.1,106.9L838.1,106.9z"
    />
  </svg>
);
